import { tk } from "../lib/i18n";

/** Titles and details are Bahasa Melayu keys; the UI translates them with t(). */
export const WORLDS = [
  { year: 1, title: tk("Istana Ajaib"), detail: tk("Langkah pertama, penemuan besar."), color: "#f5ad67", badge: "ISTANA" },
  { year: 2, title: tk("Taman Fantasi"), detail: tk("Ilmu berkembang di setiap sudut."), color: "#e79fc1", badge: "TAMAN" },
  { year: 3, title: tk("Hutan Pengembaraan"), detail: tk("Ikuti denai. Temui jawapannya."), color: "#68b899", badge: "HUTAN" },
  { year: 4, title: tk("Dunia Angkasa"), detail: tk("Bawa rasa ingin tahu ke orbit."), color: "#9a9be4", badge: "ANGKASA" },
  { year: 5, title: tk("Bandar Ilmu"), detail: tk("Bina idea, satu demi satu."), color: "#75bbd9", badge: "BANDAR" },
  { year: 6, title: tk("Dunia Futuristik"), detail: tk("Bersedia untuk pengembaraan seterusnya."), color: "#81c8c2", badge: "MASA DEPAN" },
] as const;

export type MascotAction = "idle" | "blink" | "walk" | "run" | "wave" | "point" | "jump" | "read" | "write" | "celebrate" | "correct" | "wrong" | "look";

export type WorldSubject = {
  slug: "bahasa_melayu" | "bahasa_inggeris" | "matematik" | "sains" | "sejarah";
  name: string;
  mark: string;
  color: string;
  action: MascotAction;
  description: string;
  /**
   * "language": the exercise text IS the lesson (Malay or English wording), so it is never translated.
   * "ui": the exercise follows the interface language.
   */
  content: "language" | "ui";
  question: string;
  options: readonly string[];
  answer: number;
};

// These are the five primary subject families actually present in the repository.
// Sejarah begins in Tahun 4. Jawi is an existing Tadika activity; it is not
// misrepresented as a full Pendidikan Islam DSKP course.
export const SUBJECTS: readonly WorldSubject[] = [
  { slug: "bahasa_melayu", name: tk("Bahasa Melayu"), mark: "Aa", color: "#d78075", action: "read", description: tk("Buku cerita & huruf"), content: "language", question: "Pilih perkataan yang bermula dengan huruf B.", options: ["Buku", "Meja", "Kerusi"], answer: 0 },
  { slug: "bahasa_inggeris", name: tk("Bahasa Inggeris"), mark: "Hi!", color: "#7b91ce", action: "point", description: tk("Words & conversations"), content: "language", question: "Which word means kucing?", options: ["Bird", "Cat", "Fish"], answer: 1 },
  { slug: "matematik", name: tk("Matematik"), mark: "123", color: "#d6a34e", action: "write", description: tk("Nombor, bentuk & idea"), content: "ui", question: tk("Berapakah 6 + 7?"), options: ["12", "13", "14"], answer: 1 },
  { slug: "sains", name: tk("Sains"), mark: "H₂O", color: "#5eab92", action: "point", description: tk("Eksperimen & penemuan"), content: "ui", question: tk("Bahagian tumbuhan manakah menyerap air?"), options: [tk("Bunga"), tk("Daun"), tk("Akar")], answer: 2 },
  { slug: "sejarah", name: tk("Sejarah"), mark: "1957", color: "#ad86bc", action: "point", description: tk("Kisah, peta & garis masa"), content: "ui", question: tk("Bilakah Persekutuan Tanah Melayu mencapai kemerdekaan?"), options: ["1957", "1963", "1970"], answer: 0 },
];

/**
 * Mascot guidance. `message` is a Bahasa Melayu key written as tk(...) at the call site; the speech
 * bubble translates it with t(message, vars). Values in `vars` must already be in the UI language.
 */
export function guide(action: MascotAction, message?: string, vars?: Record<string, string | number>) {
  window.dispatchEvent(new CustomEvent("jc-guide", { detail: { action, message, vars } }));
}
